import React from 'react';
import { connect } from 'react-redux';

import { Panel } from 'components/Panel';
import { Table, Td } from 'components/Table';

const EventsX = ({ events }) => (
    <Panel id="home-page-events">
        <div className="cc-panel-heading">
            <h2>Events</h2>
        </div>
        <div className="cc-panel-body">
            <Table compact>
                <tbody>{events.map((item, index) => <EventItem key={index} item={item} />)}</tbody>
            </Table>
        </div>
    </Panel>
);

const Events = connect(state => ({
    events: state.data.events
}))(EventsX);

export default Events;

const EventItem = ({ item }) => (
    <tr>
        <Td min className="cc-table-row-header">
            {item.short_date}
        </Td>
        <Td left wrap>
            <span dangerouslySetInnerHTML={{ __html: item.description }} />
        </Td>
    </tr>
);



// WEBPACK FOOTER //
// ./src/views/home/Events.jsx